import userService from '../../../services/UserService';
import applicationsActionsService from '../../../services/ApplicationActionService';
import { UserMutationTypes } from './mutations';
import { UserState } from './state';
import { ActionTree } from 'vuex';
import companyService from '../../../services/CompanyService';
import _ from 'lodash';
import Application from '../../../models/Application';
import UserRole from '../../../models/UserRole';
import UserPasswordChange from '../../../models/UserPasswordChange';

export enum UserActionTypes {
  LOAD_INFO = 'LOAD_INFO',
  LOAD_APPS = 'LOAD_APPS',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  LOAD_APPLICATIONS_ACTIONS = 'LOAD_APPLICATIONS_ACTIONS',
}

export const actions: ActionTree<UserState, {}> = {
  async [UserActionTypes.LOAD_INFO]({ commit, dispatch, state }) {
    if (!state.loaded) {
      const userInfo = await userService.getUserInfo();
      if (userInfo.roles) { userInfo.roles = JSON.parse(userInfo.roles as string); }
      if (userInfo.owner) { userInfo.owner = JSON.parse(userInfo.owner as string); }
      commit(UserMutationTypes.SET_INFO, userInfo);
      if (!process.env.VUE_APP_CURRENT_APP_CODE || process.env.VUE_APP_CURRENT_APP_CODE !== '000') {
        await dispatch(UserActionTypes.LOAD_APPS);
      }
      commit(UserMutationTypes.SET_LOADED, true);
    }
  },
  async [UserActionTypes.LOAD_APPS]({ commit, state }) {
    const userProfiles = await  userService.getUserProfile(state.info!.subject as string);
    
    const companyApps = await companyService.listActivationsByCompanyId(state.info!.company!);
    let applicationsAux = _.uniqBy(_.map(companyApps, 'Application'), 'Id');
    let applications: Application[] = [];
    applicationsAux.map((activation) => {
        if (state.info.owner || userProfiles.Profiles.some(x => x.ApplicationId == activation.Id )) {
            applications.push(activation);
      }
    });
    commit(UserMutationTypes.SET_APPS, applications);
  },
  async [UserActionTypes.CHANGE_PASSWORD](context, payload: { id: string, data: UserPasswordChange }) {
    await userService.changePassword(payload.id, payload.data);
  },
  async [UserActionTypes.LOAD_APPLICATIONS_ACTIONS](context, payload: { locale: string, application: string }) {
    const { locale, application } = payload;
    const stored = (context.state.applicationsActions[application] || {})[locale];
    if (!stored || !stored.loaded) {
      const app = context.state.allowedApps!.find((a) => a.Id === application)!;
      const data = await applicationsActionsService.load(app.Url!, payload.locale);
      context.commit(UserMutationTypes.SET_LOCALE_ACTIONS, {
        application,
        locale,
        data,
      });
    }
  }
};
